<template>
  <div class="active-record">
    <div
      class="public-list-template"
      v-for="data in datas"
      :key="data.id"
      @click="goDetail(data.id)"
    >
      <div class="news-left">
        <img :src="data.img | filterB" alt v-if="data.img==null?false:true" />
      </div>
      <div class="news-right">
        <p>{{data.title}}</p>
        <p>
          <!-- <span style="margin-right:.5rem;">浏览:{{data.sees}}</span>
          <span>点赞:{{data.praise}}</span>-->
          <span style="float:right;margin-right:.3rem">{{data.time|times}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: []
    };
  },
  methods: {
    getMsg() {
      this.axios
        .post("/api/Party/ActivityCount", {
          typename: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.datas = e.data.msg;
              break;
            default:
              break;
          }
        });
    },
    goDetail(newsid) {
      this.$router.push({
        path: "/publicDetail",
        query: { title: "三会一课资讯", id: newsid, dbnum: 3 }
      });
    }
  },
  mounted() {
    this.getMsg();
  },
  filters: {
    filterB: function(value) {
      if (value != undefined)
        return value.indexOf("http")
          ? value
          : `http://dpadmin.djplus.cn/Pimg/${value}`;
    }
  }
};
</script>
<style lang='scss' scoped>
.active-record {
  .public-list-template {
    font-size: 0.3rem;
    width: 94%;
    margin: 0 auto;
    display: flex;
    margin-bottom: 0.2rem;
    background: #fff;
    padding: 0.2rem 0;
    border-radius: 0.16rem;
    //   align-items: center;
    .news-right {
      width: 100%;
      margin-left: 0.2rem;
      p:nth-child(1) {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        margin-bottom: 0.3rem;
        line-height: 1.8;
      }
      p:nth-child(2) {
        border-top: 0.01rem solid #e6e6e6;
        padding-top: 0.2rem;
        color: #999999;
        font-size: 0.26rem;
      }
    }
    .news-left {
      img {
        width: 2.4rem;
        height: 2rem;
        margin-left: 0.2rem;
      }
    }
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>